const manageableVehicleLabel = ({ translationsStore, vehicle }) => {
  let label = `${translationsStore.translate('common.plate')}: ${vehicle.license_plate}`;
  if (vehicle.hasOwnProperty('brand') && vehicle.hasOwnProperty('model')) {
    label = `${vehicle.brand.name} ${vehicle.model.name} - ${label}`;
  }
  return label;
};

export default { manageableVehicleLabel };
